import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon  } from 'mdbreact';
import Axios from 'axios'

import adminfaculty from '../adminfaculty/adminfaculty';
import Modalarticletyps from './Modalarticletypes';
import Modalcheckpayment from '../Modalcheckpayment';




export default class superadmincheckpayment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[],
            loading:false,

        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
      }


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           
          //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlepay.php')
                Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticlepay.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data,loading: true})

           }) 
         }, 0);

      }


      updateat(){
        setTimeout(() => {
           
          Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticlepay.php')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }



    render() {
        return (
            <MDBContainer>
            <div>
        
            <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} (ผู้ดูแลระบบกลาง)</p>
            <p className="text-right">การประชุมวิชาการระดับชาติครุศาสตร์ศึกษา ครั้งที่ 8 มหาวิทยาลัยราชภัฏกำแพงเพชร</p> 
         
               <MDBAlert color="success" >
                   <h2> <MDBIcon far icon="file-alt" /> ตรวจสอบการชำระเงิน</h2>
                </MDBAlert>
{this.state.loading === false ?<>
<div className="text-center spinner-grow text-success " role="status">
              <span className="sr-only">Loading...</span>
            </div>
</>:<>
 <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้เขียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.article.map((article,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{article.send_name}</td>
                        <td>{article.namepresent}</td>
                        <td>{article.major_precent}</td>
                            <td>
                            <MDBBtn color="indigo" size="sm" href={`https://edu.kpru.ac.th/conference/PHPAPI/upload/${article.send_uploadeword1}`}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={`https://edu.kpru.ac.th/conference/PHPAPI/upload/${article.send_uploadepdf1}`}  target="_blank">PDF</MDBBtn>
                            </td>
                        <td>  
                           {/* <Modalarticletyps  id_send={article.id_send} namearticla={article.send_name}  updateat={this.updateat} /> */}
                           <Modalcheckpayment id_send={article.id_send} namearticla={article.send_name}  updateat={this.updateat} />
                           </td>
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable>

</>}
             
               
            </div>
            </MDBContainer>
        )
    }
}
